<template>
  <div v-if="visible" class="overlay"></div>
  <div v-if="visible" class="print-modal">
    <!-- Printing State -->
    <div v-if="state === 'printing'" class="modal-content">
      <SpinnerLarge />
      <div class="modal-text">{{ printingText }}</div>
    </div>

    <!-- Error State -->
    <div v-else-if="state === 'error'" class="modal-content">
      <div class="error-icon">⚠️</div>
      <div class="error-title">{{ errorTitle }}</div>
      <div class="error-message">{{ errorMessage }}</div>
      <div class="modal-buttons">
        <button class="btn-cancel" @click="cancel">{{ cancelText }}</button>
        <button class="btn-retry" @click="retry">{{ retryText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerLarge from '@/components/features/SpinnerLarge.vue';

export default {
  name: 'PrintReceiptModal',
  components: {
    SpinnerLarge,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: 'printing', // 'printing' | 'error'
      validator: (value) => ['printing', 'error'].includes(value),
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['retry', 'cancel'],
  computed: {
    printingText() {
      const translated = this.$t('printingReceipt');
      // Return default if translation key is returned unchanged (meaning no translation exists)
      return translated === 'printingReceipt' ? 'Printing Receipt' : translated;
    },
    errorTitle() {
      const translated = this.$t('printError');
      return translated === 'printError' ? 'Print Error' : translated;
    },
    cancelText() {
      const translated = this.$t('cancel');
      return translated === 'cancel' ? 'Cancel' : translated;
    },
    retryText() {
      const translated = this.$t('retry');
      return translated === 'retry' ? 'Retry' : translated;
    },
  },
  methods: {
    retry() {
      this.$emit('retry');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
}

.print-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--primary-white);
  border-radius: var(--border-radius-xl);
  padding: 4rem;
  min-width: 400px;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9001;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.modal-text {
  font-size: 2.5rem;
  font-weight: 600;
  margin-top: 2rem;
  color: var(--grey-dark);
}

.error-icon {
  font-size: 5rem;
  margin-bottom: 1.5rem;
}

.error-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: var(--grey-dark);
}

.error-message {
  font-size: 1.8rem;
  margin-bottom: 2.5rem;
  color: var(--grey-medium);
  max-width: 400px;
}

.modal-buttons {
  display: flex;
  justify-content: center;
}

button {
  border: none;
  cursor: pointer;
  padding: 1.2rem 3rem;
  border-radius: var(--border-radius-xxl);
  font-size: 2rem;
  font-weight: 600;
  transition: all 0.2s ease;
  margin: 0 0.75rem;
}

.btn-cancel {
  background-color: var(--primary-white);
  color: var(--brand-color);
  border: 0.125rem solid var(--brand-color);
}

.btn-cancel:hover {
  background-color: var(--grey-surface);
}

.btn-retry {
  background-color: var(--brand-color);
  color: var(--primary-white);
}

.btn-retry:hover {
  opacity: 0.9;
}
</style>

